import { c as _c } from "react/compiler-runtime";
import useProductListingData from 'hooks/useProductListingData';
import { GET_PRODUCTS_STATIC_DATA } from '@/graphql/queries';
import getVisitorLocationQueryVariables from 'commons/getVisitorLocationQueryVariables';
import useUserLocation from 'global-state/userLocation/useUserLocation';

// This hook should be used when we need to render an instance of
// ProductListingPage for a set of known product IDs. Since it includes the
// same functionality as category pages (e.g. sorting, filtering, restoring
// scroll position), it should not be used when rendering a set of product
// cards in isolation (e.g. product card carousels) - for those use cases,
// useStaticProductCardData should be used instead.

const DEFAULT_ALGOLIA_HITS = [];
const useStaticProductListingPageData = (t0, options) => {
  const $ = _c(25);
  const {
    productIds: t1,
    showSearchProductsOnly: t2,
    algoliaHits: t3,
    algoliaFilters,
    facetFilters,
    isAlgoliaInitialDataLoading,
    resetAlgoliaFilters,
    setActiveAlgoliaFilter,
    serverSidePaginationEnabled: t4
  } = t0;
  let t5;
  if ($[0] !== t1) {
    t5 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const productIds = t5;
  const showSearchProductsOnly = t2 === undefined ? false : t2;
  const algoliaHits = t3 === undefined ? DEFAULT_ALGOLIA_HITS : t3;
  const serverSidePaginationEnabled = t4 === undefined ? false : t4;
  const userLocation = useUserLocation();
  const zipCode = userLocation?.zip ?? "";
  const t6 = userLocation?.stateShortName;
  let t7;
  if ($[2] !== t6) {
    t7 = getVisitorLocationQueryVariables(t6);
    $[2] = t6;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== productIds || $[5] !== showSearchProductsOnly || $[6] !== t7 || $[7] !== zipCode) {
    t8 = {
      productIds,
      showSearchProductsOnly,
      zipCode,
      ...t7
    };
    $[4] = productIds;
    $[5] = showSearchProductsOnly;
    $[6] = t7;
    $[7] = zipCode;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = serverSidePaginationEnabled ? 12 : -1;
  const t10 = options?.skip || productIds.length === 0;
  let t11;
  if ($[9] !== serverSidePaginationEnabled || $[10] !== t10 || $[11] !== t8 || $[12] !== t9) {
    t11 = {
      variables: t8,
      limit: t9,
      skip: t10,
      serverSidePaginationEnabled
    };
    $[9] = serverSidePaginationEnabled;
    $[10] = t10;
    $[11] = t8;
    $[12] = t9;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== algoliaFilters || $[15] !== algoliaHits || $[16] !== facetFilters || $[17] !== isAlgoliaInitialDataLoading || $[18] !== options || $[19] !== resetAlgoliaFilters || $[20] !== setActiveAlgoliaFilter) {
    t12 = {
      ...options,
      algoliaHits,
      algoliaFilters,
      facetFilters,
      resetAlgoliaFilters,
      setActiveAlgoliaFilter,
      isAlgoliaInitialDataLoading
    };
    $[14] = algoliaFilters;
    $[15] = algoliaHits;
    $[16] = facetFilters;
    $[17] = isAlgoliaInitialDataLoading;
    $[18] = options;
    $[19] = resetAlgoliaFilters;
    $[20] = setActiveAlgoliaFilter;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  const pageData = useProductListingData(GET_PRODUCTS_STATIC_DATA, t11, t12);
  let t13;
  if ($[22] !== pageData || $[23] !== productIds.length) {
    t13 = productIds.length > 0 ? {
      ...pageData,
      isAlexandriaDataLoading: pageData.isInitialDataLoading
    } : {
      isAlexandriaDataLoading: pageData.loading,
      loading: false,
      products: [],
      productsToPreload: []
    };
    $[22] = pageData;
    $[23] = productIds.length;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
};
export default useStaticProductListingPageData;